import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LIABILITIES_ACTION_TYPE } from '../actions';

const initialState = {};

const liabilitiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LIABILITIES_ACTION_TYPE.GET_LIABILITIES:
        return payload || initialState;

      case LIABILITIES_ACTION_TYPE.DELETE_LIABILITY:
        delete draft[meta.liabilityId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default liabilitiesReducer;
